import { apiRequest } from 'src/common/utils/apiFetch';
import { LISTING_API_PREFIX } from 'src/common/constants';
import { SnoozeApiResponse, SnoozeRequestBody } from 'src/admin/common/components/SnoozeModal/types';

const bulkSnoozeListings = async (data: SnoozeRequestBody): Promise<SnoozeApiResponse> => {
  const url = `${LISTING_API_PREFIX}snooze`;
  try {
    const response = await apiRequest(url, {
      method: 'PATCH',
      body: JSON.stringify({
        data,
      }),
    });
    if (response.ok) {
      return { success: true };
    }
    return { success: false };
  } catch (error) {
    return { success: false };
  }
};

export default bulkSnoozeListings;
